import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { catchError, map, Observable, of } from 'rxjs';
import { TokenStorage } from 'src/app/core/token-storage';
import { Credential } from 'src/app/models/credential';
import { User } from 'src/app/models/user';
import { ServiceBase } from './service-base';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends ServiceBase {
  constructor(
    private http: HttpClient,
    private tokenStorage: TokenStorage,
    private userService: UsersService
  ) {
    super();
  }

  logon(account: string, password: string): Observable<boolean> {
    const credential = new Credential(account, password);

    // Adds a session id
    sessionStorage.setItem('SessionId', Guid.create().toString());

    let isAuthenticated: boolean = false;

    return this.http
      .post(`${this.apiUrl}/api/token`, credential, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      })
      .pipe(
        map((response: any) => {
          if (response.accessToken) {
            // Saves the token
            this.tokenStorage.saveToken(response.accessToken);
            // Saves in session the user account while waiting to get their infos back
            const user = new User();
            user.account = account;
            sessionStorage.setItem('user', JSON.stringify(user));
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          return isAuthenticated;
        }),
        catchError(() => {
          return of(false);
        })
      );
  }

  logout(token: string) {
    const params = new HttpParams().set('token', token);

    this.http
      .delete(`${this.apiUrl}/api/token`, { params: params })
      .subscribe();

    this.userService.removeCurrentUser();

    // Supprime le token
    this.tokenStorage.signOut();
  }
}
